export const questionnaire_background = {
    name: '問卷',
    subtitle: '&nbsp;',
    sections: [
        [
            {
                id: '1',
                type:'single-choice',
                options: [
                    'A. 男 ',
                    'B. 女'
                ],
                question:'1. 你的性別是'
            },
            {
                id: '2',
                type:'date',
                question: '2. 你的出生日期是：',
            },
            {
                id: '3',
                type:'single-choice',
                options: [
                    'A. 碩士及以上',
                    'B. 大專或本科',
                    'C. 中等職業教育（例如VTC, IVE, HKCT等）',
                    'D. 普通高中',
                    'E. 初中',
                    'F. 小學',
                    'G. 沒有讀完小學'
                ],
                question:'3. 你母親的受教育程度是： 如果你不確定選哪個選項，請尋求測試人員的協助。（只選一個答案）'
            },
            {
                id: '4',
                type:'single-choice',
                options: [
                    'A. 碩士及以上',
                    'B. 大專或本科',
                    'C. 中等職業教育（例如VTC, IVE, HKCT等）',
                    'D. 普通高中',
                    'E. 初中',
                    'F. 小學',
                    'G. 沒有讀完小學'
                ],
                question:'4. 你父親的受教育程度是：如果你不確定選哪個選項，請尋求測試人員的協助。（只選一個答案）'
            },
        ],
        [
            {   
                id: '5',
                type: 'table',
                title: '5. 你家中有下列物品嗎？ （請在每行選擇一個答案）',
                options: [
                    '有',
                    '沒有'
                ],
                questions: [
                    { question: '1. 一張學習用的書桌' },
                    { question: '2. 一個專屬自己的房間' },
                    { question: '3. 一個安靜的學習場所' },
                    { question: '4. 一台可用來完成學校作業的電腦' },
                    { question: '5. 一台可以用於學習的平板' },
                    { question: '6. 互聯網連接' }
                ]

            },
            {
                id: '6-1',
                type:'single-choice',
                options: [
                    '0-10本',
                    '11-25本',
                    '26-100本',
                    '101-200本',
                    '201-500本',
                    '超過500本'
                ],
                question:'6-1. 你家裏有多少本書？ 每一米長的書架上通常可以放大約40本書。請不要將雜誌、報紙和你的課本計算在內。（請在下面的選項中選擇一個答案）'
            },
        ],
        [
            {
                id: '6-2',
                type:'single-choice',
                options: [
                    '0-10本',
                    '11-25本',
                    '26-100本',
                    '101-200本',
                    '201-500本',
                    '超過500本'
                ],
                question:'6-2. 你有多少本電子書？ （包含已經閲讀過的和還未閲讀過的）'
            },
        ],
        [
            {
                id: '7',
                type:'single-choice',
                options: [
                    'A. 公務員',
                    'B. 工商界管理人員',
                    'C. 科研人員或大學老師',
                    'D. 專業人士（如醫生、律師、會計、設計師、工程師）',
                    'E. 技術人員（如廚師、技工、修理工、保險銷售、地產經紀）',
                    'F. 中小學幼稚園教師（含補習老師）',
                    'G. 個體經營者',
                    'H. 工商企業職員（如文員）',
                    'I. 工人（侍應、售貨員、收銀員、外賣員、司機、保安、建築工人）',
                    'J.臨時工',
                    'K. 無業人員（如家庭主婦）',
                    'L. 其他（請寫出）'
                ],
                question:'7. 你母親主要從事甚麼工作？（如果她現在沒有工作，請填上她曾從事的最後一份工作。）'
            },
        ],
        [
            {
                id: '8',
                type:'single-choice',
                options: [
                    'A. 公務員',
                    'B. 工商界管理人員',
                    'C. 科研人員或大學老師',
                    'D. 專業人士（如醫生、律師、會計、設計師、工程師）',
                    'E. 技術人員（如廚師、技工、修理工、保險銷售、地產經紀）',
                    'F. 中小學幼稚園教師（含補習老師）',
                    'G. 個體經營者',
                    'H. 工商企業職員（如文員）',
                    'I. 工人（侍應、售貨員、收銀員、外賣員、司機、保安、建築工人）',
                    'J.臨時工',
                    'K. 無業人員（如家庭主婦）',
                    'L. 其他（請寫出）'
                ],
                question:'8. 你父親主要從事甚麼工作？（如果他現在沒有工作，請填上他曾從事的最後一份工作。）'
            },
        ]
        
    ]
}